import { envConfig } from '../config/config.web'

const ERROR_MISSING_CLIENT_ID = 'Failed to generate ID.me redirectUrl: missing clientId'
const ERROR_MISSING_SUBSCRIBE_URL = 'Failed to generate ID.me redirectUrl: missing subscribeUrl'

export const ACCOUNTS_IDME_REDIRECT_URL = `${envConfig.PFF_DOMAIN}/accounts/v3/idme/cb`

export const getIdMeRedirectUrl = (isLoggedIn: boolean, originUrl: string, clientId?: string) => {
  if (!clientId) {
    throw new Error(ERROR_MISSING_CLIENT_ID)
  }
  if (!isLoggedIn && !process.env.NEXT_PUBLIC_SUBSCRIBE_URL) {
    throw new Error(ERROR_MISSING_SUBSCRIBE_URL)
  }
  const redirectUri = isLoggedIn ? ACCOUNTS_IDME_REDIRECT_URL : process.env.NEXT_PUBLIC_SUBSCRIBE_URL
  return `https://groups.id.me/?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scopes=military,student,responder&state=${encodeURIComponent(`?redirectTo=${originUrl}`)}`
}
